import ThirdPartyJobPaymentsAdmin from './ThirdPartyJobPaymentsAdmin';

export default class PendingReviewTpJobTab extends ThirdPartyJobPaymentsAdmin {
  getType() {
    return 'pending_review';
  }
}
